import api from "../common/api_config";
import {getData, postData, postDataWithoutToken, getDataSSO} from "../utils/ajax";
import ACTION from "../common/action_constant";
import { put, call } from 'redux-saga/effects';
import {getCookie,setCookie,setCompressedCookie} from "../utils/cookies"
// import history from "../history";
import {GENERIC_TOKEN} from "../utils/common";
import CompanyUser from "Models/User";

function* login(action) {    
    try{
        const data = yield call(postData, api.login, (action.data));
        if(action.onSuccess){
            action.onSuccess(data)
        }
        if(data.data.is_password_expired) {
            location.href = `/changepassword`;
            setCookie('change-token', data.data.token, 200);
        } else {
            // setCookie("user", JSON.stringify(data.data));
            const userModel = new CompanyUser(data.data);
            // setCookie("user", JSON.stringify(userModel));
            setCompressedCookie("user", userModel);
            action.history.push("/home");
            yield put({type: ACTION.LOGIN.STORE_USER, user: data.data});
        }
    }
    catch(error){
        if(action.onError){
            action.onError(error)
        }
        if(error && error.responseJSON.data && error.responseJSON.data == 1) {
            action.onError(error.responseJSON.data);
        }
        yield put({ type : ACTION.MSG_DISPLAY.SHOW_MSG, data : { type : 1 , msg : error.responseJSON.message}});

    }
}

function* validateSSOLogin(action) {    
    try{
        const data = yield call(postDataWithoutToken, api.ssoUserValidation, (action.data), GENERIC_TOKEN);
        if(action.onSuccess){
            action.onSuccess(data.data)
        }
    }
    catch(error){
        yield put({ type : ACTION.MSG_DISPLAY.SHOW_MSG, data : { type : 1 , msg : error.responseJSON.message}});

    }
}

function* ssoLogin(action) {    
    try{
        const data = yield call(getDataSSO, api.ssoLoginResponse, (action.data));
        const userModel = new CompanyUser(data.data);
        // setCookie("user", JSON.stringify(userModel));
        // setCookie("user", JSON.stringify(data.data));
        setCompressedCookie("user", userModel);
        if(action.onSuccess){
            action.onSuccess(data.data)
        }
        action.history.push("/home");
        yield put({type: ACTION.LOGIN.STORE_USER, user: data.data});
    }
    catch(error){
        yield put({ type : ACTION.MSG_DISPLAY.SHOW_MSG, data : { type : 1 , msg : error.responseJSON.message}});

    }
}

function* ssoConfig(action) {    
    try{
        const data = yield call(postDataWithoutToken, api.ssoConfigResponse, (action.data), GENERIC_TOKEN);
        yield put({type: ACTION.LOGIN.STORE_SSO_CONFIG_DATA, ssoConfigData: data.data});
    }
    catch(error){
        yield put({ type : ACTION.MSG_DISPLAY.SHOW_MSG, data : { type : 1 , msg : error.responseJSON.message}});
    }
}

function* postForgotPasswordDetails(action) {
    try{
        yield put({
            type: ACTION.LOADER.SHOW_LOADER,
          });
        const data = yield call(postDataWithoutToken, api.forgotPassword, action.data);
        yield put({
            type: ACTION.LOADER.HIDE_LOADER,
        });
        yield put({ type : ACTION.MSG_DISPLAY.SHOW_MSG, data : { type : 1 , msg : data.message }});

        if(action.onSuccess) {
            action.onSuccess(data);
        }
    } catch(e) {
        yield put({
            type: ACTION.LOADER.HIDE_LOADER,
        });
        yield put({ type : ACTION.MSG_DISPLAY.SHOW_MSG, data : { type : 1 , msg : e.responseJSON.message}});
    }
}

function* resetPassword(action) {    
    try {
        yield put({
            type: ACTION.LOADER.SHOW_LOADER,
          });
        const data = yield call(postData, api.resetPassword, action.data, false, action.token);

        yield put({ type : ACTION.MSG_DISPLAY.SHOW_MSG, data : { type : 1 , msg : data.message || ''}});

        if(action.onSuccess) {
            action.onSuccess(data);
        }
        yield put({
            type: ACTION.LOADER.HIDE_LOADER,
        });
        
    } catch(e) {
        yield put({
            type: ACTION.LOADER.HIDE_LOADER,
        });
        yield put({ type : ACTION.MSG_DISPLAY.SHOW_MSG, data : { type : 1 , msg : e.responseJSON.message}});
        
        if(action.onError){
            action.onError(e)
        }
    }
}

function* changePassword(action) {
    try{
        yield put({
            type: ACTION.LOADER.SHOW_LOADER,
          });
        const data = yield call(postData, api.changePassword, (action.data));
        yield put({
            type: ACTION.LOADER.HIDE_LOADER,
        });
        if(action.onSuccess) {
            action.onSuccess(data.data);
        }
    }
    catch(error){
         yield put({
            type: ACTION.LOADER.HIDE_LOADER,
        });
        if(action.onError){
            action.onError(error)
        }
        if(error && error.responseJSON.data && error.responseJSON.data == 1 && action.onError) {
            action.onError(error.responseJSON.data);
        }
        yield put({ type : ACTION.MSG_DISPLAY.SHOW_MSG, data : { type : 1 , msg : error.responseJSON.message}});
    }
}

export {
    login,
    ssoLogin,
    validateSSOLogin,
    ssoConfig,
    postForgotPasswordDetails,
    resetPassword,
    changePassword
};
